import { createReducer } from "@reduxjs/toolkit";
import { IWebsocketActions } from "./websocket-actions";

export interface IWebsocketModel {
  isConnected: boolean;
}

const INITIAL_STATE: IWebsocketModel = {
  isConnected: true, // we start as true here to prevent from showing the "offline" message on the first load
};

/** Reducer */
export const websocketReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(IWebsocketActions.setIsConnected, (state): IWebsocketModel => {
      return {
        ...state,
        isConnected: true,
      };
    })
    .addCase(IWebsocketActions.setIsDisconnected, (state): IWebsocketModel => {
      return {
        ...state,
        isConnected: false,
      };
    });
});
